import AddressHelpers from '../services/helpers/AddressHelpers';

export default function useMaps() {
  function getGoogleMapsUrl(data) {
    const query = [AddressHelpers.format(data ?? {}, data?.address_format), data?.country].filter(Boolean).join(', ');

    const encodedQuery = encodeURIComponent(query);

    return `https://www.google.com/maps/search/?api=1&query=${encodedQuery}`;
  }

  return {
    getGoogleMapsUrl,
  };
}
